import css_qnzbu0hq3uj from './css/TitleBarContainer.css';
import Div from './Div.js';
import MenuButton from './MenuButton.js';
import Title from './Title.js';
import FloatCloseButton from './FloatCloseButton.js';

const css = css_qnzbu0hq3uj;

export default class TitleBarContainer extends Div
{
	constructor(parentElement)
	{
		super(parentElement);
		this.barkerTitle = new BarkerTitle(this);
		this.prepend = new Prepend(this);
		this.title = new Title(this);
		this.menuButton = new MenuButton(this);
		this.floatCloseButton = new FloatCloseButton(this);

		this.barkerTitle.value = config.feed.barkerTitle;
	}

	get cssText()
	{
		return css;
	}
}

class Prepend extends Title { }
class BarkerTitle extends Title
{
	get cssText()
	{
		return '.videoPlayer:not(.barker) .barkerTitle{display:none}'
	}
}
